'use client'

import { JSX } from 'react'
import { Category } from '@/payload-types'
import { Locale } from '@/providers/Locale/types'

import { type Props as OneColListProps } from '@/components/frontend/Layouts/OneColList'
import { i18n, CategoryMeta } from './i18n'
import { PostList } from '@/components/frontend/PostList'
import { GoogleTagManager } from '@/providers/GoogleTagManager'

type Props = {
    categoryKey: string
    category: Category
    nextPage: number
    locale: Locale
    contentType?: 'sub_category' | 'category'
    options?: OneColListProps
}

export function SubCategoryClient({ category, categoryKey, nextPage, locale, contentType = 'sub_category', options = {} }: Props): JSX.Element {
    const posts = category.relatedPosts?.docs
    const meta: Record<string, CategoryMeta | undefined> = i18n[locale]

    return (
        <>
            <GoogleTagManager
                event='page_view'
                gtmData={{
                    content_type: contentType,
                    content_category: category.slug || '',
                    content_id: category.id,
                    content_title: category.title,
                }}
            />
            <PostList
                options={{
                    heading: {
                        title: category.title,
                        tagline: category.description || meta[categoryKey]?.description || '',
                    },
                    affiliateDisclaimerLink: '/welcome-to-the-inventory-1825927863?_ga=2.160038781.1759048496.1559637839-2127544484.1559637839',
                    ...options,
                }}
                classes={{ nextButton: 'hover:bg-slate-200' }}
                nextPage={nextPage}
                hasNextPage={!!category.relatedPosts?.hasNextPage}
                nextButtonText='Next'
                locale={locale}
                posts={posts}
            />
        </>
    )
}
